import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "../pages/Home";
import CyberRisks from "../pages/CyberRisks";
import TerminBuchen from "../pages/TerminBuchen";
import FAQ from "../pages/FAQ";
import Tarifwissen from "../pages/Tarifwissen";
import AllianzTarif from "../pages/tarife/AllianzTarif";
import HiscoxTarif from "../pages/tarife/HiscoxTarif";
import HdiTarif from "../pages/tarife/HdiTarif";
import MarkelTarif from "../pages/tarife/MarkelTarif";
import VhvTarif from "../pages/tarife/VhvTarif";
import AxaTarif from "../pages/tarife/AxaTarif";
import AlteLeipzigerTarif from "../pages/tarife/AlteLeipzigerTarif";
import RvTarif from "../pages/tarife/RvTarif";
import StoikTarif from "../pages/tarife/StoikTarif";
import NuernbergerTarif from "../pages/tarife/NuernbergerTarif";
import CogitandaTarif from "../pages/tarife/CogitandaTarif";
import ErgoTarif from "../pages/tarife/ErgoTarif";
import ZurichTarif from "../pages/tarife/ZurichTarif";
import GothaerTarif from "../pages/tarife/GothaerTarif";
import SignalIdunaTarif from "../pages/tarife/SignalIdunaTarif";
import WuerttembergischeTarif from "../pages/tarife/WuerttembergischeTarif";
import NotFound from "../pages/NotFound";
import WeitereVersicherungen from "../pages/WeitereVersicherungen";
import Auth from "../pages/Auth";
import ResetPassword from "../pages/ResetPassword";
import Inhaltsversicherung from "../pages/versicherungen/Inhaltsversicherung";
import Berufshaftpflicht from "../pages/versicherungen/Berufshaftpflicht";
import Betriebshaftpflicht from "../pages/versicherungen/Betriebshaftpflicht";
import Rechtsschutz from "../pages/versicherungen/Rechtsschutz";
import Praxisausfallversicherung from "../pages/versicherungen/Praxisausfallversicherung";
import Elektronikversicherung from "../pages/versicherungen/Elektronikversicherung";
import Erstinformation from "../pages/Erstinformation";
import Impressum from "../pages/Impressum";
import Datenschutz from "../pages/Datenschutz";
import UeberUns from "../pages/UeberUns";
import Newsletter from "../pages/Newsletter";
import NewsletterAbmelden from "../pages/NewsletterAbmelden";
import BlogDashboard from "../pages/admin/BlogDashboard";
import BlogEditor from "../pages/admin/BlogEditor";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminEinstellungen from "../pages/admin/AdminEinstellungen";
import SeoValidierung from "../pages/admin/SeoValidierung";
import LeadsDashboard from "../pages/admin/LeadsDashboard";
import AnalyticsDashboard from "../pages/admin/AnalyticsDashboard";
import Blog from "../pages/Blog";
import BlogPost from "../pages/BlogPost";
import BlogCategories from "../pages/BlogCategories";
import CyberversicherungHub from "../pages/CyberversicherungHub";
import CyberversicherungStadt from "../pages/stadt/CyberversicherungStadt";
import VergleichsrechnerCyber from "../pages/cyberversicherung/VergleichsrechnerCyber";
import Sitemap from "../pages/Sitemap";
import Team from "../pages/Team";
import HausarztPraxis from "../pages/praxistypen/HausarztPraxis";
import ZahnarztPraxis from "../pages/praxistypen/ZahnarztPraxis";
import MVZPraxis from "../pages/praxistypen/MVZPraxis";
import KlinikPraxis from "../pages/praxistypen/KlinikPraxis";
import FacharztPraxis from "../pages/praxistypen/FacharztPraxis";
import RansomwareSchutz from "../pages/schadensfall/RansomwareSchutz";
import Datenverlust from "../pages/schadensfall/Datenverlust";
import DsgvoBussgelder from "../pages/schadensfall/DsgvoBussgelder";
import Betriebsunterbrechung from "../pages/schadensfall/Betriebsunterbrechung";
import PatientendatenDiebstahl from "../pages/schadensfall/PatientendatenDiebstahl";
import PhishingSchutz from "../pages/schadensfall/PhishingSchutz";
import CyberChecklisteLanding from "../pages/CyberChecklisteLanding";
import Glossar from "../pages/Glossar";
import GlossarBegriff from "../pages/glossar/GlossarBegriff";
import SchadensfallPage from "../pages/schadensfall/SchadensfallPage";
import VersicherungsRechner from "../pages/VersicherungsRechner";
import DsgvoComplianceCenter from "../pages/DsgvoComplianceCenter";
import DevicePreviewToggle from "./DevicePreviewToggle";
import GitControls from "./GitControls";
import VisualEditor from "./VisualEditor";
import { useAuth } from "../hooks/useAuth";
import { ProtectedRoute } from "./ProtectedRoute";

export const AppContent = () => {
  const { isAdmin, loading } = useAuth();

  return (
    <>
      <ScrollToTop />
      
      {/* Admin-Only Debug Tools - NUR für eingeloggte Admins sichtbar */}
      {!loading && isAdmin && (
        <>
          <DevicePreviewToggle />
          <GitControls />
          <VisualEditor />
        </>
      )}
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cyberrisiken" element={<CyberRisks />} />
        <Route path="/termin-buchen" element={<TerminBuchen />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/tarifwissen" element={<Tarifwissen />} />
        <Route path="/tarifwissen/allianz" element={<AllianzTarif />} />
        <Route path="/tarifwissen/hiscox" element={<HiscoxTarif />} />
        <Route path="/tarifwissen/hdi" element={<HdiTarif />} />
        <Route path="/tarifwissen/markel" element={<MarkelTarif />} />
        <Route path="/tarifwissen/vhv" element={<VhvTarif />} />
        <Route path="/tarifwissen/axa" element={<AxaTarif />} />
        <Route path="/tarifwissen/alte-leipziger" element={<AlteLeipzigerTarif />} />
        <Route path="/tarifwissen/ruv" element={<RvTarif />} />
        <Route path="/tarifwissen/stoik" element={<StoikTarif />} />
        <Route path="/tarifwissen/nuernberger" element={<NuernbergerTarif />} />
        <Route path="/tarifwissen/cogitanda" element={<CogitandaTarif />} />
        <Route path="/tarifwissen/ergo" element={<ErgoTarif />} />
        <Route path="/tarifwissen/zurich" element={<ZurichTarif />} />
        <Route path="/tarifwissen/gothaer" element={<GothaerTarif />} />
        <Route path="/tarifwissen/signal-iduna" element={<SignalIdunaTarif />} />
        <Route path="/tarifwissen/wuerttembergische" element={<WuerttembergischeTarif />} />
        <Route path="/weitere-versicherungen" element={<WeitereVersicherungen />} />
        <Route path="/weitere-versicherungen/inhaltsversicherung" element={<Inhaltsversicherung />} />
        <Route path="/weitere-versicherungen/berufshaftpflicht" element={<Berufshaftpflicht />} />
        <Route path="/weitere-versicherungen/betriebshaftpflicht" element={<Betriebshaftpflicht />} />
        <Route path="/weitere-versicherungen/rechtsschutz" element={<Rechtsschutz />} />
        <Route path="/weitere-versicherungen/praxisausfall" element={<Praxisausfallversicherung />} />
        <Route path="/weitere-versicherungen/elektronik" element={<Elektronikversicherung />} />
        <Route path="/erstinformation" element={<Erstinformation />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/team" element={<Team />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/newsletter/abmelden" element={<NewsletterAbmelden />} />
        <Route path="/sitemap" element={<Sitemap />} />
        
        {/* Auth Routes */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/kategorien" element={<BlogCategories />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        
        {/* Cyberversicherung Hub & Praxistypen */}
        <Route path="/cyberversicherung" element={<CyberversicherungHub />} />
        <Route path="/cyberversicherung/vergleichsrechner" element={<VergleichsrechnerCyber />} />
        <Route path="/cyberversicherung/hausarztpraxis" element={<HausarztPraxis />} />
        <Route path="/cyberversicherung/zahnarztpraxis" element={<ZahnarztPraxis />} />
        <Route path="/cyberversicherung/mvz" element={<MVZPraxis />} />
        <Route path="/cyberversicherung/klinik" element={<KlinikPraxis />} />
        <Route path="/cyberversicherung/facharztpraxis" element={<FacharztPraxis />} />
        
        {/* Schadensfall-Seiten */}
        <Route path="/cyberversicherung/ransomware-schutz" element={<RansomwareSchutz />} />
        <Route path="/cyberversicherung/datenverlust" element={<Datenverlust />} />
        <Route path="/cyberversicherung/dsgvo-bussgelder" element={<DsgvoBussgelder />} />
        <Route path="/cyberversicherung/betriebsunterbrechung" element={<Betriebsunterbrechung />} />
        <Route path="/cyberversicherung/patientendaten-diebstahl" element={<PatientendatenDiebstahl />} />
        <Route path="/cyberversicherung/phishing-schutz" element={<PhishingSchutz />} />
        
        {/* Stadt-Landingpages */}
        <Route path="/cyberversicherung/:city" element={<CyberversicherungStadt />} />
        
        {/* Cyber-Checkliste Landing */}
        <Route path="/cyber-checkliste" element={<CyberChecklisteLanding />} />
        
        {/* Glossar */}
        <Route path="/glossar" element={<Glossar />} />
        <Route path="/glossar/:slug" element={<GlossarBegriff />} />
        
        {/* Real-Case Schadensfälle */}
        <Route path="/schadensfall/:slug" element={<SchadensfallPage />} />
        
        {/* Tools */}
        <Route path="/versicherungsrechner" element={<VersicherungsRechner />} />
        <Route path="/dsgvo-compliance-center" element={<DsgvoComplianceCenter />} />

        
        {/* Admin Routes */}
        <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/blog" element={<ProtectedRoute><BlogDashboard /></ProtectedRoute>} />
        <Route path="/admin/blog/edit/:id" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute><LeadsDashboard /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
        <Route path="/admin/seo-validierung" element={<ProtectedRoute><SeoValidierung /></ProtectedRoute>} />
        <Route path="/admin/einstellungen" element={<ProtectedRoute><AdminEinstellungen /></ProtectedRoute>} />
        
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
